(() => {
  const initialize = () => document.querySelectorAll('[data-ep-form]').forEach(form => {
    if (form.dataset.epReady) return;
    form.dataset.epReady = 'true';
    const button = form.querySelector('button[type="submit"]');
    const sync = () => {
      const selected = form.querySelector('input[name="selling_plan"]:checked');
      if (selected && !button.disabled) button.textContent = selected.dataset.cta;
    };
    form.addEventListener('change', sync);
    form.addEventListener('submit', () => {
      const selected = form.querySelector('input[name="selling_plan"]:checked');
      if (selected && !selected.value) selected.disabled = true;
    });
    sync();
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-ep-form] input[type="radio"]').forEach(input => { input.disabled = false; });
    initialize();
  });
})();
